module.exports = __webpack_public_path__ + "static/media/cred-5.aa89227b.gif";